import { render, staticRenderFns } from "./ProductShowConfig.vue?vue&type=template&id=1839b636&scoped=true&"
import script from "./ProductShowConfig.vue?vue&type=script&lang=js&"
export * from "./ProductShowConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1839b636",
  null
  
)

export default component.exports